import React, { Suspense, lazy } from "react";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import { AuthProvider } from "contexts/AuthContext";
import ModelViewerContainer from "containers/modelViewerContainer";
// import Personalise from "containers/personalise";
// import DummyProduct, { DummyProductCopy } from "containers/dummyProduct";
// import ProductDemo from "containers/productDemo";
// import UploadAssets from "containers/uploadAssets";
// import {
//   ReactCanvasSceneComponentCopy
// } from "containers/babylon";
// import AvatarForm from "containers/avatarForm";
// import Login from "containers/login";
// import SelfieModule1 from "containers/selfieModule/SelfieModule1";
// import SelfieModule from "containers/selfieModule";
// import OrientationInfo from "containers/deviceOrientation"
// import SandBox from "containers/sandbox";
// import AssetViewer from "containers/assetViewer";
// import Products from "containers/Products";
// import AppModule from "containers/AppModule";
const Personalise = lazy(() => import("containers/personalise"));
const ProductDemo = lazy(() => import("containers/productDemo"));
const AppModule = lazy(() => import("containers/appModule"));
const AssetViewer = lazy(() => import("containers/assetViewer"));
const SandBox = lazy(() => import("containers/sandbox"));
const FitHotspotDemo = lazy(() => import("containers/fitHotspotDemo/FitHotspotDemo"));
const YourFitDemo = lazy(() => import("containers/yourFitDemo/YourFitDemo"));
const OrientationInfo = lazy(() => import("containers/deviceOrientation"));
const SelfieModule = lazy(() => import("containers/selfieModule"));
const UploadAssets = lazy(() => import("containers/uploadAssets"));
const Login = lazy(() => import("containers/login"));
const PepeFunnelDashboard = lazy(() =>
  import("containers/pepeFunnelDashboard/PepeFunnelDashboard")
);
const EnamorFunnelDashboard = lazy(() =>
  import("containers/enamorFunnelDashboard/EnamorFunnelDashboard")
);
const SelfieModule1 = lazy(() =>
  import("containers/selfieModule/SelfieModule1")
);
const AvatarForm = lazy(() => import("containers/avatarForm"));
const KioskDemo = lazy(() => import("containers/kioskDemo/KioskDemo"));
const SizeRecommendation = lazy(() => import("containers/sizeRecommendation"));
const BareNecessitiesDemo = lazy(() =>
  import("containers/bareNecessitiesDemo/BareNecessitiesDemo")
);
const BareNecessitiesInline = lazy(() =>
  import("containers/bareNecessitiesDemo/BareNecessitiesInline")
);
const BareNecessitiesGallery = lazy(() =>
  import("containers/bareNecessitiesDemo/BareNecessitiesGallery")
);
const BareNecessitiesSecond = lazy(() =>
  import("containers/bareNecessitiesDemo/BareNecessitiesSecond")
);
const JockeySecond = lazy(() =>
  import("containers/jockeyDemo/JockeySecond")
);
const Jockey1722 = lazy(() =>
  import("containers/jockeyDemo/Jockey1722")
);
const Jockey1842 = lazy(() =>
  import("containers/jockeyDemo/Jockey1842")
);
const Jockey1842Inline = lazy(() =>
  import("containers/jockeyDemo/Jockey1842Inline")
);
const Jockey1722Inline = lazy(() =>
  import("containers/jockeyDemo/Jockey1722Inline")
);
const Jockey216Inline = lazy(() =>
  import("containers/jockeyDemo/Jockey216Inline")
);
const JockeyMI10Inline = lazy(() =>
  import("containers/jockeyDemo/JockeyMI10Inline")
);
const JockeyJW11Inline = lazy(() =>
  import("containers/jockeyDemo/JockeyJW11Inline")
);
const Jockey1820Inline = lazy(() =>
  import("containers/jockeyDemo/Jockey1820Inline")
);
const FitDemoInline = lazy(() =>
  import("containers/demo/FitDemoInline")
);
const Jockey1820Turntable = lazy(() =>
  import("containers/jockeyDemo/Jockey1820Turntable")
);
const EnamorA077Inline = lazy(() =>
  import("containers/enamorDemo/EnamorA077Inline")
);
const JockeyFE93Inline = lazy(() =>
  import("containers/jockeyDemo/JockeyFE93Inline")
);
const Jockey1841Inline = lazy(() =>
  import("containers/jockeyDemo/Jockey1841Inline")
);
const Jockey1816Inline = lazy(() =>
  import("containers/jockeyDemo/Jockey1816Inline")
);
const CosabellaDemo = lazy(() =>
  import("containers/cosabellaDemo/CosabellaDemo")
);
const JockeyDashboard = lazy(() =>
  import("containers/jockeyDashboard/JockeyDashboard")
);
const BareNecessitiesFavorite = lazy(() =>
  import("containers/bareNecessitiesDemo/BareNecessitiesFavorite")
);
const BareNecessitiesFavoriteInline = lazy(() =>
  import("containers/bareNecessitiesDemo/BareNecessitiesFavoriteInline")
);
const BareNecessitiesFavoriteSecond = lazy(() =>
  import("containers/bareNecessitiesDemo/BareNecessitiesFavoriteSecond")
);
const PepeSizePreview = lazy(() => import("containers/pepeSizePreview"));
// eslint-disable-next-line react/display-name
const Component = (RouteComponent) => (props) => <RouteComponent {...props} />;
const ComponentWithAuth =
  (RouteComponent, anonymousLogin, localRoute = true) =>
  (props) => {
    return (
      <AuthProvider anonymousLogin={anonymousLogin} localRoute={localRoute}>
        <RouteComponent {...props} />
      </AuthProvider>
    );
  };

/**
  * This component's sole purpose is routes management
  * Components being called using "loginHOC" are authenticated components.
    They'll prompt login screen first if the user is not logged in.
  * Components being rpassed directly (without loginHOC) are public pages.
    Login will not be prompted. If in case some part/flow of the component requires
    user-authentication, It can use "LoginWrapper" or "loginHOC" internally.
*/

const history = createBrowserHistory();
const Routes = () => {
  return (
    <Router history={history}>
      <Suspense fallback={<div></div>}>
        <Switch>
          <Route
            exact
            path="/demo1"
            component={ComponentWithAuth(() => (
              <ProductDemo showAll={true} />
            ))}
          />
          <Route
            exact
            path="/adidas"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          {/* <Route
          exact
          path="/abfrl"
          component={ComponentWithAuth(() => (
            <ProductDemo />
          ))}
        />
        <Route
          exact
          path="/abfrlm"
          component={ComponentWithAuth(() => (
            <ProductDemo />
          ))}
        />
        <Route
          exact
          path="/abfrlf"
          component={ComponentWithAuth(() => (
            <ProductDemo />
          ))}
        /> */}
          <Route
            exact
            path="/dopplr-avatar/:domain"
            component={ComponentWithAuth(
              () => (
                <AppModule anonymousLogin={true} />
              ),
              true,
              false
            )}
          />
          <Route
            exact
            path="/size-recommendor/:domain"
            component={ComponentWithAuth(
              () => (
                <SizeRecommendation />
              ),
              true,
              true
            )}
          />
          <Route
            exact
            path="/preview/pepe-size/:productType"
            component={Component(() => (
              <PepeSizePreview />
            ))}
          />
          <Route
            exact
            path="/pepe-funnel-dashboard"
            component={Component(() => (
              <PepeFunnelDashboard />
            ))}
          />
          <Route
            exact
            path="/enamor-funnel-dashboard"
            component={Component(() => (
              <EnamorFunnelDashboard />
            ))}
          />
          <Route
            exact
            path="/plugin/:domain"
            component={ComponentWithAuth(
              () => (
                <KioskDemo anonymousLogin={true} />
              ),
              true,
              true
            )}
          />
          <Route
            exact
            path="/dopplr-plugin/:domain"
            component={ComponentWithAuth(
              () => (
                <AppModule anonymousLogin={true} />
              ),
              true,
              true
            )}
          />
          {/* <Route
          exact
          path="/dopplr-avatar-old"
          component={ComponentWithAuth(() => (
            <ReactCanvasSceneComponentCopy />
          ))}
        /> */}
          <Route
            exact
            path="/personalise"
            component={ComponentWithAuth(() => (
              <Personalise />
            ))}
          />
          <Route
            exact
            path="/avatar-form"
            component={ComponentWithAuth(() => (
              <AvatarForm />
            ))}
          />
          <Route
            exact
            path="/login"
            component={ComponentWithAuth(() => (
              <Login />
            ))}
          />
          <Route
            path="/adidas2"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/lightbox"
            component={ComponentWithAuth(() => (
              <SandBox uploadMode={true} />
            ))}
          />
          <Route
            exact
            path="/sandbox"
            component={ComponentWithAuth(() => (
              <SandBox />
            ))}
          />
          <Route
            exact
            path="/uploadAssets"
            component={Component(() => (
              <UploadAssets />
            ))}
          />
          <Route
            exact
            path="/demo/:brandId"
            component={ComponentWithAuth(() => (
              <AssetViewer />
            ))}
          />
          <Route
            exact
            path="/oasis"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/valentino"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/misschase"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/indianterrain"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/eberjay"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/gap"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/chicago"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/dopplr"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/lotto"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/indianterrain-live"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              true
            )}
          />
          <Route
            exact
            path="/suitview"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              true
            )}
          />
          <Route
            exact
            path="/rarerabbit-live"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              true
            )}
          />
          {/* <Route
          exact
          path="/SAN"
          component={ComponentWithAuth(() => (
            <Products />
          ))}
        /> */}
          <Route
            exact
            path="/ccclub"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/cava"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/test"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/beinghuman"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/rarerabbit"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/burgerbae"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/lacoste-demo"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              true
            )}
          />
          <Route
            exact
            path="/dopplr-demo"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/superkicks"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/fef"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/aldeno"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/iff-25"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/spacelines"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/fef-demo"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/rarerabbit-demo"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              true
            )}
          />
          <Route
            exact
            path="/ralphlauren"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              true
            )}
          />
          <Route
            exact
            path="/fashor"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          {/* Enamor embedded customizer — paused. Renders an empty page so
              any existing iframe consumers fail gracefully (no auth flow,
              no React errors) until we re-enable. */}
          <Route
            exact
            path="/enamor"
            component={() => null}
          />
          <Route
            exact
            path="/BHuman"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/beinghumans"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/gyro"
            component={ComponentWithAuth(
              () => (
                <OrientationInfo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/virgio"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/forevernew"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/iff"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/nicobar"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/stylox"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/etail"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/revolve"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/freepeople"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/retrofete"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/selfie"
            component={ComponentWithAuth(
              () => (
                <SelfieModule bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/selfie1"
            component={Component(() => (
              <SelfieModule1 bypassLogin={false} />
            ))}
          />
          <Route
            exact
            path="/nicobar-test"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          <Route
            exact
            path="/puma"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/puma-female"
            component={ComponentWithAuth(() => (
              <ProductDemo />
            ))}
          />
          {/* Enamor embedded customizer — paused (duplicate fallback route). */}
          <Route
            exact
            path="/lanebryant"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={false} />
              ),
              false
            )}
          />
          <Route
            exact
            path="/enamor-demo"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              true
            )}
          />
          <Route
            exact
            path="/superkicks-demo"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              true
            )}
          />
          <Route
            exact
            path="/fila"
            component={ComponentWithAuth(
              () => (
                <ProductDemo bypassLogin={true} />
              ),
              true
            )}
          />
          <Route
            exact
            path="/selfie/:token/:jobId"
            component={Component(() => (
              <SelfieModule />
            ))}
          />
          <Route
            exact
            path="/model-viewer"
            component={Component(() => (
              <ModelViewerContainer />
            ))}
          />
          <Route
            exact
            path="/barenecessities/products/bare-the-smooth-multiway-strapless-bra-b30267v1"
            component={Component(() => (
              <BareNecessitiesDemo />
            ))}
          />
          <Route
            exact
            path="/barenecessities/products/bare-the-smooth-multiway-strapless-bra-b30267v1/inline"
            component={Component(() => (
              <BareNecessitiesInline />
            ))}
          />
          <Route
            exact
            path="/barenecessities/products/bare-the-smooth-multiway-strapless-bra-b30267v1/gallery"
            component={Component(() => (
              <BareNecessitiesGallery />
            ))}
          />
          <Route
            exact
            path="/barenecessities/products/bare-the-smooth-multiway-strapless-bra-b30267v1/second"
            component={Component(() => (
              <BareNecessitiesSecond />
            ))}
          />
          <Route
            exact
            path="/barenecessities/products/bare-the-favorite-wire-free-smoothing-t-shirt-bra-b10246"
            component={Component(() => (
              <BareNecessitiesFavorite />
            ))}
          />
          <Route
            exact
            path="/barenecessities/products/bare-the-favorite-wire-free-smoothing-t-shirt-bra-b10246/inline"
            component={Component(() => (
              <BareNecessitiesFavoriteInline />
            ))}
          />
          <Route
            exact
            path="/barenecessities/products/bare-the-favorite-wire-free-smoothing-t-shirt-bra-b10246/second"
            component={Component(() => (
              <BareNecessitiesFavoriteSecond />
            ))}
          />
          <Redirect exact from="/demo/bare/1" to="/barenecessities/products/bare-the-smooth-multiway-strapless-bra-b30267v1/second" />
          <Redirect exact from="/demo/bare/2" to="/barenecessities/products/bare-the-favorite-wire-free-smoothing-t-shirt-bra-b10246/second" />
          <Redirect exact from="/bare/1" to="/barenecessities/products/bare-the-smooth-multiway-strapless-bra-b30267v1/second" />
          <Redirect exact from="/bare/2" to="/barenecessities/products/bare-the-favorite-wire-free-smoothing-t-shirt-bra-b10246/second" />
          <Redirect exact from="/jockey/1" to="/jockeydemo/1722" />
          <Redirect exact from="/jockey/2" to="/jockeydemo/1842" />
          <Route
            exact
            path="/jockey/products/1831"
            component={Component(() => (
              <JockeySecond />
            ))}
          />
          <Route
            exact
            path="/jockey/products/1722"
            component={Component(() => (
              <Jockey1722 />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/1722"
            component={Component(() => (
              <Jockey1722 />
            ))}
          />
          <Route
            exact
            path="/jockey/products/1842"
            component={Component(() => (
              <Jockey1842 />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/1842"
            component={Component(() => (
              <Jockey1842 />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/1842/inline"
            component={Component(() => (
              <Jockey1842Inline />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/216/inline"
            component={Component(() => (
              <Jockey216Inline />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/MI10/inline"
            component={Component(() => (
              <JockeyMI10Inline />
            ))}
          />
          <Route
            exact
            path="/fithotspot"
            component={Component(() => (
              <FitHotspotDemo />
            ))}
          />
          <Route
            exact
            path="/yourfit"
            component={Component(() => (
              <YourFitDemo />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/JW11/inline"
            component={Component(() => (
              <JockeyJW11Inline />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/1816/inline"
            component={Component(() => (
              <Jockey1816Inline />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/1820/inline"
            component={Component(() => (
              <Jockey1820Inline />
            ))}
          />
          <Route
            exact
            path="/fitdemo"
            component={Component(() => (
              <FitDemoInline />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/1820/turntable"
            component={Component(() => (
              <Jockey1820Turntable />
            ))}
          />
          <Route
            exact
            path="/enamordemo/a077"
            component={Component(() => (
              <EnamorA077Inline />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/FE93/inline"
            component={Component(() => (
              <JockeyFE93Inline />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/1841/inline"
            component={Component(() => (
              <Jockey1841Inline />
            ))}
          />
          {/* Tone-test path: same Jockey 1842 shell, but the inner React app
              detects /skin-natural and swaps the SkinToneSelector swatches
              from MST to the 6-tone Natural palette and seeds the Controls
              panel with a "Natural" lighting preset. Use band 36, cup BC,
              shape "apple", placement "regular" to land on body
              75668bd4987d — the only body with the new skin_* GLBs baked. */}
          <Route
            exact
            path="/jockeydemo/1842/skin-natural"
            component={Component(() => (
              <Jockey1842Inline />
            ))}
          />
          <Route
            exact
            path="/jockeydemo/1722/inline"
            component={Component(() => (
              <Jockey1722Inline />
            ))}
          />
          <Route
            exact
            path="/jockey/dashboard"
            component={Component(() => (
              <JockeyDashboard />
            ))}
          />
          <Route
            exact
            path="/cosabella/products/lisciante-strapless-bra-black-en"
            component={Component(() => (
              <CosabellaDemo />
            ))}
          />
        </Switch>
      </Suspense>
    </Router>
  );
};

export default Routes;
